const PausasHome = () => import(/* webpackChunkName: "group-callcenter-cadastros" */ '../_views/PausasHome')
const CadastroPausa = () => import(/* webpackChunkName: "group-callcenter-cadastros" */ '../_views/CadastroPausa')
const AtualizarPausa = () => import(/* webpackChunkName: "group-callcenter-cadastros" */ '../_views/AtualizarPausa')

import { permissionsCadastroPausa } from '../../../../../utils/permissionsCallCenter'

export default [
  {
    path: 'pausa',
    meta: { requiresAuth: true, permissions: [...permissionsCadastroPausa] },
    component: PausasHome,
    name: 'Pausa',
  },
  {
    path: 'pausa/criar',
    meta: {
      requiresAuth: true,
      permissions: [process.env.VUE_APP_ADMINISTRADOR, process.env.VUE_APP_CALLCENTER_CADASTRO_PAUSA_TOTAL],
    },
    component: CadastroPausa,
    name: 'Pausa/criar',
  },
  {
    path: 'pausa/atualizar/:_id',
    meta: { requiresAuth: true, permissions: [...permissionsCadastroPausa] },
    component: AtualizarPausa,
    name: 'Pausa/atualizar',
    props: true,
  },
]
